/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Claims
 */
export interface Claims {
    /**
     * 
     * @type {string}
     * @memberof Claims
     */
    typ?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Claims
     */
    val?: string | null;
}

/**
 * Check if a given object implements the Claims interface.
 */
export function instanceOfClaims(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClaimsFromJSON(json: any): Claims {
    return ClaimsFromJSONTyped(json, false);
}

export function ClaimsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Claims {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'typ': !exists(json, 'typ') ? undefined : json['typ'],
        'val': !exists(json, 'val') ? undefined : json['val'],
    };
}

export function ClaimsToJSON(value?: Claims | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'typ': value.typ,
        'val': value.val,
    };
}

